var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _polygon2, _ellipse, _path7, _polygon3, _polygon4, _path8, _polygon5, _path9, _circle, _path10, _circle2, _path11, _polygon6, _circle3, _path12, _polygon7, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlbums(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ab80713a-a851-46d9-b7e4-877a3942e50e",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 797.58746,
    height: 517.33747,
    viewBox: "0 0 797.58746 517.33747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fd60ad6d-234f-4794-b327-6c250fb58182",
    "data-name": "Path 461",
    d: "M874.15874,672.75553a22.728,22.728,0,0,0,21.947-3.866c7.687-6.452,10.1-17.081,12.058-26.924l5.8-29.112-12.143,8.362c-8.733,6.013-17.662,12.219-23.709,20.929s-8.686,20.6-3.828,30.024",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bb4d4dd3-dbdc-44b5-88db-bf6307e476a1",
    "data-name": "Path 462",
    d: "M875.19675,708.00151c-1.229-8.953-2.493-18.02-1.631-27.069.766-8.036,3.217-15.885,8.209-22.321a37.13192,37.13192,0,0,1,9.527-8.633c.953-.6,1.829.909.881,1.507a35.29989,35.29989,0,0,0-13.963,16.847c-3.04,7.732-3.528,16.161-3,24.374.317,4.967.988,9.9,1.665,14.83a.9.9,0,0,1-.61,1.074.878.878,0,0,1-1.074-.61Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "fe08dba1-9a00-49ac-809e-caf1a04d3592",
    "data-name": "Path 482",
    d: "M973.28873,707.64354s-12.753-31.391,25.505-54.934Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "ae08b72c-0170-4ceb-bc44-c76ada017e82",
    "data-name": "Path 483",
    d: "M957.60477,707.0725s-3.89-22.374-34-22.182Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M252.8995,432.36063H533.25741V234.59891H252.8995Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M539.25741,438.36063H246.8995V228.59891H539.25741Zm-286.35791-6H533.25741V234.59891H252.8995Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "26.878 222.855 24.811 222.855 24.811 21.869 305.177 21.869 305.177 23.952 26.878 23.952 26.878 222.855",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "2.068 200.986 0 200.986 0 0 280.366 0 280.366 2.083 2.068 2.083 2.068 200.986",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.87215,
    cy: 142.14847,
    rx: 59.95938,
    ry: 60.40009,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M393.07846,394.87967c-33.61328,0-60.95948-27.54394-60.95948-61.3999s27.3462-61.3999,60.95948-61.3999c33.613,0,60.95923,27.54394,60.95923,61.3999S426.69149,394.87967,393.07846,394.87967Zm0-120.7998c-32.51026,0-58.95948,26.64648-58.95948,59.3999s26.44922,59.3999,58.95948,59.3999,58.95923-26.64648,58.95923-59.3999S425.58871,274.07987,393.07846,274.07987Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.301 112.182 175.301 173.156 225.051 142.252 175.301 112.182",
    fill: "#ff9100"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.259 504.614 504.072 504.614 498.75 461.462 515.261 461.462 515.259 504.614",
    fill: "#ffb7b7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M719.31886,706.79043l-36.07363-.00134v-.45627a14.0416,14.0416,0,0,1,14.04086-14.04064h.00089l22.03254.00089Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "611.378 488.26 601.998 494.358 574.014 461.081 587.858 452.081 611.378 488.26",
    fill: "#ffb7b7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M820.88739,687.12857l-30.24431,19.66186-.2487-.38254a14.0416,14.0416,0,0,1,4.11838-19.42483l.00075-.00049,18.47223-12.00873Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 543.84609,
    cy: 86.99416,
    r: 10.30833,
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M735.32175,282.07464a10.30978,10.30978,0,0,1,6.66193-16.40193,10.30589,10.30589,0,1,0,1.28148,20.48838A10.28288,10.28288,0,0,1,735.32175,282.07464Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 533.16701,
    cy: 123.46982,
    r: 30.28074,
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M706.158,303.77059a30.2753,30.2753,0,0,1,39.20982-15.289c-.30554-.15284-.60914-.30825-.922-.45188a30.28075,30.28075,0,0,0-25.2692,55.03784c.31286.14364.62866.27259.94368.40468A30.27533,30.27533,0,0,1,706.158,303.77059Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "569.908 282.368 591.609 394.944 620.092 479.035 573.977 488.53 529.218 320.345 527.861 481.749 469.539 483.105 483.103 386.805 499.57 278.086 569.908 282.368",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 533.26194,
    cy: 133.19644,
    r: 20.34496,
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M753.48179,354.91669l-31.1956.78165L700.58494,366.549l2.71268,62.39116-5.25945,47.77769s-1.966,7.488,11.59731,14.26963c4.34043,2.17022,9.931,3.09034,15.527,3.33821a50.29878,50.29878,0,0,0,31.86617-10.07651c2.84458-2.0846,5.99595-3.47782,8.66018-2.41214,6.78165,2.71266,8.138-5.42531,8.138-5.42531l-8.138-39.3336,12.207-37.40256-12.32924-40.1514Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "514.481 111.924 514.481 134.576 519.728 134.576 526.404 127.423 525.51 134.576 548.698 134.576 547.268 127.423 550.129 134.576 553.825 134.576 553.825 111.924 514.481 111.924",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M759.10343,318.886a2.48122,2.48122,0,0,0-2.46494-2.24455h-2.4899V333.0521h2.4899a2.48122,2.48122,0,0,0,2.46494-2.24455,5.846,5.846,0,0,0,4.32568-5.64125v-.639A5.846,5.846,0,0,0,759.10343,318.886Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M714.10893,331.01492h-2.75284a5.8486,5.8486,0,0,1-5.84862-5.84861v-.639a5.8486,5.8486,0,0,1,5.84862-5.84862h2.75284v12.33627Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M714.78805,333.05211h-2.4899a2.4899,2.4899,0,0,1-2.48989-2.4899h0V319.13136a2.4899,2.4899,0,0,1,2.48989-2.4899h2.4899v16.41065Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M757.77071,319.53732h-1.82509c0-12.8897-9.55054-23.376-21.28976-23.376-11.74012,0-21.29066,10.48626-21.29066,23.376h-1.82509c0-13.89582,10.36951-25.20105,23.11575-25.20105C747.4012,294.33627,757.77071,305.6415,757.77071,319.53732Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M683.41913,509.69608a8.55691,8.55691,0,0,0,2.57416-12.866l9.39781-17.14762-9.02766-8.25258L673.432,495.832a8.60329,8.60329,0,0,0,9.9871,13.86405Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ffb7b7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M707.36659,366.549l-3.65113-1.78886s-8.55584,1.78886-11.26847,7.21417-9.49428,61.03485-9.49428,61.03485l-5.42531,36.62092s-4.069,0-4.069,4.069-5.42531,14.91963-1.35634,14.91963,20.345,0,23.0576-2.71265,8.138-13.56329,6.78166-14.91963-4.069-1.35632-4.069-1.35632l3.816-36.71442Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M780.2613,496.94915a8.55686,8.55686,0,0,1,.76543-13.09865l-4.75263-18.96767,10.82218-5.69947,6.33542,26.88028a8.60328,8.60328,0,0,1-13.1704,10.88551Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ffb7b7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M766.64923,420.91565l3.816,36.71442s-2.71263,0-4.069,1.35632,4.069,12.207,6.78166,14.91963,18.98862,2.71265,23.0576,2.71265-1.35635-10.85063-1.35635-14.91963-4.069-4.069-4.069-4.069l-5.42531-36.62092s-6.78166-49.60953-9.49429-55.03485-11.26847-7.21417-11.26847-7.21417L760.971,360.549Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M692.264,497.35046l-.17506.11106-3.0428-4.796a3.28732,3.28732,0,0,0-4.5369-1.01471l-10.161,6.4466a3.28734,3.28734,0,0,0-1.01471,4.5369h0l16.693,26.3114a3.28731,3.28731,0,0,0,4.5369,1.01471l10.161-6.4466a3.28734,3.28734,0,0,0,1.01472-4.5369l-11.4843-18.10148.17506-.11109Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M688.46755,493.0597,705.136,519.33234a2.45507,2.45507,0,0,1-.75781,3.38826l-10.20976,6.47749a2.45509,2.45509,0,0,1-3.38824-.75781l-16.66846-26.27264a2.45508,2.45508,0,0,1,.75781-3.38826l1.2386-.78578a1.167,1.167,0,0,0,1.77277.77818l5.82116-3.69317a1.16693,1.16693,0,0,0,.05114-1.93536l1.32616-.84136A2.45509,2.45509,0,0,1,688.46755,493.0597Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#ff9100"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M990.48375,708.66873h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-201.20627 -191.33127)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbums);
export default __webpack_public_path__ + "static/media/albums.70e0c3d384431f1484b194ec6858b5ae.svg";
export { ForwardRef as ReactComponent };